import styled from 'styled-components'

const FactsStyle = styled.div`
	--factPadding: var(--sp6x) var(--sp5x);
	--titleMarginTopBottom: var(--sp3x) 0 var(--sp4x) 0;
	--factBorderRadius: var(--sp2x);
	--factMarginTop: 0;
	--factsMainTitleMarginBottom: var(--sp8x);

	.main-title {
		margin-bottom: var(--factsMainTitleMarginBottom);
	}

	.fact-wrap {
		margin-top: var(--factMarginTop);

		&:nth-child(-n + 2) {
			margin-top: 0;
		}

		&.three-facts {
			&:nth-child(n) {
				margin-top: 0;
			}
		}

		.fact {
			height: 100%;
			padding: var(--factPadding);
			background-color: var(--primaryColor3);
			border-radius: var(--factBorderRadius);

			.title {
				margin: var(--titleMarginTopBottom);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--factPadding: var(--sp5x) var(--sp4x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp3x) 0;
		--factsMainTitleMarginBottom: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--factPadding: var(--sp5x) var(--sp4x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp3x) 0;
		--factsMainTitleMarginBottom: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--factPadding: var(--sp5x) var(--sp4x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp3x) 0;
		--factMarginTop: var(--sp4x);
		--factsMainTitleMarginBottom: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--factPadding: var(--sp4x) var(--sp3x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp2x) 0;
		--factMarginTop: var(--sp4x);
		--factsMainTitleMarginBottom: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--factPadding: var(--sp4x) var(--sp3x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp2x) 0;
		--factMarginTop: var(--sp2x);
		--factsMainTitleMarginBottom: var(--sp4x);

		.fact-wrap {
			&.three-facts {
				&:nth-child(n) {
					margin-top: 0;
				}

				&:last-child {
					margin-top: var(--factMarginTop);
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--factPadding: var(--sp4x) var(--sp3x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp2x) 0;
		--factMarginTop: var(--sp2x);
		--factsMainTitleMarginBottom: var(--sp4x);

		.fact-wrap {
			&.three-facts {
				&:nth-child(n) {
					margin-top: 0;
				}

				&:last-child {
					margin-top: var(--factMarginTop);
				}
			}
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--factPadding: var(--sp4x) var(--sp3x);
		--titleMarginTopBottom: var(--sp2x) 0 var(--sp2x) 0;
		--factMarginTop: var(--sp2x);
		--factsMainTitleMarginBottom: var(--sp4x);

		.fact-wrap {
			&:nth-child(n + 2) {
				margin-top: var(--factMarginTop);
			}
		}

		.fact-wrap {
			&.three-facts {
				&:nth-child(n) {
					margin-top: var(--factMarginTop);
				}
				&:first-child {
					margin-top: 0;
				}
			}
		}
	}
`

export default FactsStyle
